var _defs, _polygon, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEv11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.5;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20.92 7.53 20.92 6.15 24.53 9.37 20.92 12.6 20.92 11.22 15.64 11.22 15.64 7.53 20.92 7.53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.64,2.7c5.18,0,10.36.65,10.36,5.18v12.3c0,1.23-.49,2.34-1.29,3.16v2.67c0,.71-.58,1.29-1.29,1.29h-1.29c-.71,0-1.29-.58-1.29-1.29v-1.29h-10.36v1.29c0,.71-.58,1.29-1.29,1.29h-1.29c-.71,0-1.29-.58-1.29-1.29v-2.67c-.8-.82-1.29-1.93-1.29-3.16V7.88c0-4.53,4.63-5.18,10.36-5.18Zm4.53,18.12c1.07,0,1.94-.87,1.94-1.94s-.87-1.94-1.94-1.94-1.94.87-1.94,1.94.87,1.94,1.94,1.94Zm-9.06,0c1.07,0,1.94-.87,1.94-1.94s-.87-1.94-1.94-1.94-1.94.87-1.94,1.94.87,1.94,1.94,1.94Zm-3.24-7.77h15.54v-6.47c-.78-.67-3.21-1.29-7.77-1.29-4.8,0-7.07.6-7.77,1.29v6.47Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.17,
    cy: 18.88,
    r: 1.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.42,6.5h-3.12c-1.26,0-2.29,1.03-2.29,2.29v3.12c0,1.26,1.03,2.29,2.29,2.29h.81v11.91c0,.41.34.75.75.75s.75-.34.75-.75v-11.91h.81c1.26,0,2.29-1.03,2.29-2.29v-3.12c0-1.26-1.03-2.29-2.29-2.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEv11);
export default __webpack_public_path__ + "static/media/EV11.4e3efa89c7f34ae16917bb5b312cd412.svg";
export { ForwardRef as ReactComponent };